import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=0c0f8516&scoped=true&"
import script from "./Resultado.vue?vue&type=script&lang=js&"
export * from "./Resultado.vue?vue&type=script&lang=js&"
import style0 from "./Resultado.vue?vue&type=style&index=0&id=0c0f8516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f8516",
  null
  
)

export default component.exports